interface ErrorMessageProps {
  message: string | null
}

export function ErrorMessage(props: ErrorMessageProps) {
  const { message } = props

  if (!message) return null

  return <p className="text-v2-foreground-danger text-body">{message}</p>
}
